export default __webpack_public_path__ + "static/media/seoul.d3c3552a.jpeg";